import { RootState } from '../store'

export const phonesSelector = (state: RootState) => {
  const { phones } = state

  return phones
}
